module.exports = __webpack_public_path__ + "static/media/Brandon_reg.135f0bcc.woff";